<template>
  <Toast
    :pt="{
      root: {
        id: 'toastPanel',
        class: `z-[99999999999] fixed  right-[20px]`,
        style: showClearAll ? 'top: 50px;' : undefined,
      },
      messageContent: { class: 'border-l-[6px] border-[currentColor] rounded-l-md' },
      message: { class: 'toastMessage  relative' },
      container: { class: 'relative' },
      closeButton: ({ props }) => ({
        onClick: () => {
          onCloseButtonClick(props.message)
        },
      }),
    }"
  >
    <template #message="{ message }">
      <LazyAppToastMessageCustom :message />
    </template>
  </Toast>
  <Teleport v-if="showClearAll" defer to="#toastPanel">
    <Button
      class="topbar-button p-link !absolute right-0 rounded-full py-1 px-2 top-[-5px] -translate-y-full"
      type="button"
      data-test-id="topBar-clearButton"
      @click="clear"
    >
      {{ $t('Smazat vše') }}
    </Button>
  </Teleport>
</template>

<script setup lang="ts">
import type { ToastMessageOptions } from 'primevue/toast'

const { messages, clear } = useToastService()

const showClearAll = computed(() => Object.keys(messages.value).length > 1)

const onCloseButtonClick = async (message: ToastMessageOptions) => {
  const ToastEventBus = await import('primevue/toasteventbus')
  const sha1 = await import('js-sha1')
  ToastEventBus.default.emit('remove', message)
  delete messages.value[sha1.default(JSON.stringify({ ...message, id: undefined }))]
}
</script>
